export const imageUrls = {
	logo: process.env.REACT_APP_ENV === "staging" ? "/MarathonStaging.png" : "/Marathon.png",
};
